// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal .ant-modal-body {
    padding: 0px 0px 0px 32px !important;
}

.app-role-select-style {
    height: 35px;
    width: 300px !important;
}

.app-role-max-height {
    max-height: 530px;
}

.input-con-all .ant-select-selector {
    max-height: 160px !important;
    overflow-y: auto !important;
    min-height: 34px !important;
    border-radius: 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/permission/role/index.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;AACjC","sourcesContent":[".ant-modal .ant-modal-body {\n    padding: 0px 0px 0px 32px !important;\n}\n\n.app-role-select-style {\n    height: 35px;\n    width: 300px !important;\n}\n\n.app-role-max-height {\n    max-height: 530px;\n}\n\n.input-con-all .ant-select-selector {\n    max-height: 160px !important;\n    overflow-y: auto !important;\n    min-height: 34px !important;\n    border-radius: 4px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
